// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-wrapper[data-v-61d02362]{margin-bottom:1rem}.input-wrapper.form-field.error input[data-v-61d02362]{border-color:#e50707}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
